<template>
  <div>
     <p>Por favor completa la siguiente información:</p>
    <form @submit.prevent="submit" novalidate>

       <!-- FORMULARIO DE FAMILIAR  PEP -->
      <fieldset>

        <!-- NOMBRE  Y APELLIDO PATERNO -->
        <div class="row row-responsive">

          <!-- INICIA LA PROFESION -->
          <div class="column column-xs-100 column-sm-50">
            <label
              for="name"
              :class="{
                'error-text': $v.userIndirectPep.name.$invalid
                && formSubmitted
               }" >
                Nombre:
            </label>
            <input
              type="text"
              v-model.trim="$v.userIndirectPep.name.$model"
              :class="{ 'error-label': $v.userIndirectPep.name.$invalid
                && formSubmitted
               }"
                placeholder="Nombre">
            <!-- INICIAN VALIDACIONES DE PROFESION -->
            <div
              v-if="formSubmitted && !$v.userIndirectPep.name.required"
              class="error"
            >
              Este campo es obligatorio.
            </div>
            <div
              v-if="formSubmitted && !$v.userIndirectPep.name.minLength"
              class="error"
            >
              El nombre debe de tener más de
              {{ $v.userIndirectPep.name.$params.minLength.min }} letras
            </div>
            <div
                v-if="formSubmitted && !$v.userIndirectPep.name.validateName"
                class="error"
              >
                El nombre es incorrecto.
            </div>
          </div>

          <!-- APELLIDO PATERNO -->
          <div class="column column-xs-100 column-sm-50">
            <label
            for="fatherSurname"
            :class="{
              'error-text': $v.userIndirectPep.fatherSurname.$invalid
              && formSubmitted
            }" >
              Apellido paterno:
            </label>
            <input type="text"
              v-model.trim="$v.userIndirectPep.fatherSurname.$model"
              :class="{ 'error-label': $v.userIndirectPep.fatherSurname.$invalid
                && formSubmitted
              }"
              placeholder="Apellido paterno">

            <!-- INICIAN VALIDACIONES DE APELLIDO PATERNO -->
            <div
              v-if="formSubmitted && !$v.userIndirectPep.fatherSurname.required"
              class="error"
            >
              Este campo es obligatorio.
            </div>
            <div
              v-if="formSubmitted && !$v.userIndirectPep.fatherSurname.minLength"
              class="error"
            >
              El nombre debe de tener más de
              {{ $v.userIndirectPep.fatherSurname.$params.minLength.min }} letras
            </div>
            <div
                v-if="formSubmitted && !$v.userIndirectPep.fatherSurname.validateName"
                class="error"
              >
                El nombre es incorrecto.
            </div>
          </div>
        </div>

        <!-- APELLIDO MATERNO Y RELACION -->
        <div class="row row-responsive">

          <!-- APELLIDO MATERNO -->
          <div class="column column-xs-100 column-sm-50">
            <label for="last_name"
              :class="{
                'error-text': $v.userIndirectPep.motherSurname.$invalid
                && formSubmitted
               }" >
                Apellido materno:
            </label>
            <input type="text"
              v-model.trim="$v.userIndirectPep.motherSurname.$model"
              :class="{ 'error-label': $v.userIndirectPep.motherSurname.$invalid
                && formSubmitted
              }"
              placeholder="Apellido materno">

            <!-- INICIAN VALIDACIONES DE APELLIDO MATERNO -->
            <div
              v-if="formSubmitted && !$v.userIndirectPep.motherSurname.required"
              class="error"
            >
              Este campo es obligatorio.
            </div>
            <div
              v-if="formSubmitted && !$v.userIndirectPep.motherSurname.minLength"
              class="error"
            >
              El nombre debe de tener más de
              {{ $v.userIndirectPep.motherSurname.$params.minLength.min }} letras
            </div>
            <div
                v-if="formSubmitted && !$v.userIndirectPep.motherSurname.validateName"
                class="error"
              >
                El nombre es incorrecto.
            </div>
          </div>

           <!-- INICIA RELACION -->
          <div class="column column-xs-100 column-sm-50">
            <label
              for="relationship"
              :class="{
                'error-text': $v.userIndirectPep.relationship.$invalid
                && formSubmitted }">
                Relación:
            </label>
            <span class="select">
              <select
                v-model.trim="$v.userIndirectPep.relationship.$model"
                :class="{ 'error-label': $v.userIndirectPep.relationship.$invalid
                && formSubmitted
                }"
              >
                <option value="" disabled selected>Seleccione:</option>
                <option
                  v-for="relation in RELATIONS.data"
                  :value="relation.value"
                  :key="relation.id">
                  {{ relation.name }}
                </option>
              </select>
              <span class="arrow"></span>
            </span>
            <!-- INICIAN VALIDACIONES DE RELACIÓN -->
            <div
              v-if="formSubmitted && !$v.userIndirectPep.relationship.required"
              class="error"
            >
              Este campo es obligatorio.
            </div>
          </div>
        </div>

        <!-- FECHADE INICIO Y TERMINO -->
        <div class="row row-responsive">

        <!-- FECHA DE INICIO -->
          <div class="column column-xs-100 column-sm-50">
            <label for="startWorkingDate"
              :class="{
                'error-text': $v.userIndirectPep.validStartDate.$invalid
                && formSubmitted
               }" >
              Fecha de inicio:
            </label>
            <DatePicker
              v-model.trim="$v.userIndirectPep.validStartDate.$model"
              :format="dateFormat"
              :monday-first="true"
              :disabled-dates="{from: new Date(), to: new Date(1900, 0, 0)}"
              :class="{ 'error-label': $v.userIndirectPep.validStartDate.$invalid
                && formSubmitted
               }"
              :language="es"
              placeholder="Fecha de nacimiento (dd-mm-aaaa)">
            </DatePicker>
            <!-- INICIA VALIDACIÓN FECHA DE INICIO  -->
            <div
              v-if="formSubmitted && !$v.userIndirectPep.validStartDate.required"
              class="error"
            >
              Este campo es obligatorio.
            </div>
          </div>
          <!-- FECHA TEERMINO -->
          <div class="column column-xs-100 column-sm-50">
            <label for="finishWorkingDate"
              :class="{
                'error-text': $v.userIndirectPep.validEndDate.$invalid
                && formSubmitted
               }" >
              Fecha de término:
            </label>
            <DatePicker
              v-model.trim="$v.userIndirectPep.validEndDate.$model"
              :format="dateFormat"
              :monday-first="true"
              :disabled-dates="{from: new Date(), to: new Date(1900, 0, 0)}"
              :class="{ 'error-label': $v.userIndirectPep.validEndDate.$invalid
                && formSubmitted
              }"
              :language="es"
              placeholder="Fecha de nacimiento (dd-mm-aaaa)"
              :disabled="keepWorkingAt">
            </DatePicker>
            <input
              v-model="keepWorkingAt"
              type="checkbox"
              id="notkeepWorkingAt"
              name="notkeepWorkingAt"
            >
            <p
              class="checkbox--label"
              for="notkeepWorkingAt"
            >
              Actualmente continua laborando.
            </p>
            <!-- INICIA VALIDACIÓN FECHA DE TERMINO  -->
            <div
              v-if="formSubmitted && !$v.userIndirectPep.validEndDate.requiredIf"
              class="error"
            >
              Este campo es obligatorio.
            </div>
            <div
              v-if="formSubmitted && !$v.userIndirectPep.validEndDate.minorThan"
              class="error"
            >
              La fecha de término debe ser mayor que la fecha de inicio
            </div>
          </div>
        </div>

        <!-- PROFESIÓN Y PUESTO -->
        <div class="row row-responsive">

        <!-- INICIA LA PROFESION -->
          <div class="column column-xs-100 column-sm-50">
            <label
              for="profession"
              :class="{ 'error-text': $v.userIndirectPep.profession.$invalid
                && formSubmitted
              }">
              Profesión:
            </label>
            <input type="text"
              v-model.trim="$v.userIndirectPep.profession.$model"
              :class="{ 'error-label': $v.userIndirectPep.profession.$invalid
                && formSubmitted
              }"
              placeholder="Profesión"
            >
            <!-- INICIAN VALIDACIONES DE PROFESION -->
            <div
              v-if="formSubmitted && !$v.userIndirectPep.profession.required"
              class="error"
            >
              Este campo es obligatorio.
            </div>
            <div
              v-if="formSubmitted && !$v.userIndirectPep.profession.minLength"
              class="error"
            >
              La profesion es incorrecta.
            </div>
          </div>
          <!-- INICIA EL PUESTO -->
          <div class="column column-xs-100 column-sm-50">
            <label for="position"
              :class="{
                'error-text': $v.userIndirectPep.position.$invalid
                && formSubmitted
              }" >
              Posición:
            </label>
            <input type="text"
              v-model.trim="$v.userIndirectPep.position.$model"
              :class="{ 'error-label': $v.userIndirectPep.position.$invalid
              && formSubmitted
              }"
              placeholder="Posición"
            >

             <!-- INICIAN VALIDACIONES DE PUESTO -->
            <div
              v-if="formSubmitted && !$v.userIndirectPep.position.required"
              class="error"
            >
              Este campo es obligatorio.
            </div>
            <div
              v-if="formSubmitted && !$v.userIndirectPep.position.minLength"
              class="error"
            >
              El puesto es incorrecto.
            </div>
          </div>
        </div>

        <!-- DEPENDENCIA Y EMPLEO ACTUAL -->
        <div class="row row-responsive">

          <!-- INICIA DEPENDENCIA DEL GOBIERNO -->
          <div class="column column-xs-100 column-sm-50">
            <label
              for="government_dependence"
              :class="{
                'error-text': $v.userIndirectPep.governmentDependence.$invalid
                && formSubmitted
               }" >
              Dependencia del gobierno:
            </label>
            <input type="text"
              v-model.trim="$v.userIndirectPep.governmentDependence.$model"
              :class="{ 'error-label': $v.userIndirectPep.governmentDependence.$invalid
                && formSubmitted
              }"
              placeholder="Dependencia del gobierno"
            >
             <!-- INICIAN VALIDACIONES DE DEPENDENCIA DEL GOBIERNO -->
            <div
              v-if="formSubmitted && !$v.userIndirectPep.governmentDependence.required"
              class="error"
            >
              Este campo es obligatorio.
            </div>
            <div
              v-if="formSubmitted && !$v.userIndirectPep.governmentDependence.minLength"
              class="error"
            >
              La dependencia de gobierno es incorrecta.
            </div>
          </div>
          <!-- INICIA EMPLEO ACTUAL -->
          <div class="column column-xs-100 column-sm-50">
            <label
              for="current_job"
              :class="{'error-text': $v.userIndirectPep.currentJob.$invalid
                && formSubmitted
              }" >
              Empleo actual:
            </label>
            <input
              type="text"
              v-model.trim="$v.userIndirectPep.currentJob.$model"
              :class="{ 'error-label': $v.userIndirectPep.currentJob.$invalid
                && formSubmitted
              }"
              placeholder="Empleo actual"
            >
            <!-- INICIAN VALIDACIONES DE EMPLEO ACTUAL -->
            <div
              v-if="formSubmitted && !$v.userIndirectPep.currentJob.required"
              class="error"
            >
              Este campo es obligatorio.
            </div>
            <div
              v-if="formSubmitted && !$v.userIndirectPep.currentJob.minLength"
              class="error"
            >
              El empleo es incorrecta.
            </div>
          </div>
        </div>

        <!-- FONDOS DEL GOBIERNO -->
        <div class="row row-responsive">

          <!-- INICIA FONDOS DEL GOBIERNO -->
          <div class="column column-xs-100 column-sm-50">
            <label
              for="gov_funds"
              :class="{
                'error-text':$v.userIndirectPep.govFunds.$invalid
                && formSubmitted
              }">
              ¿Tiene o tuvo acceso a fondos de gobierno?
            </label>
            <span class="select">
              <select
                v-model.trim="$v.userIndirectPep.govFunds.$model"
                :class="{ 'error-label': $v.userIndirectPep.govFunds.$invalid
                  && formSubmitted
                }">
                <option value="" disabled selected>Seleccione:</option>
                <option
                  v-for="option in options"
                  :value="option.value"
                  :key="option.id">{{ option.name }}
                </option>
              </select>
              <span class="arrow"></span>
            </span>
            <!-- INICIAN VALIDACIONES DE FONDOS DEL GOBIERNO -->
            <div
              v-if="formSubmitted && !$v.userIndirectPep.govFunds.required"
              class="error"
            >
              Este campo es obligatorio.
            </div>
          </div>
        </div>
        <div class="row">
          <div class="column box-errors">
            <p v-if="errors" class="error">El formulario tiene errores, por favor revísalos antes de seguir.
            </p>
            <p v-else-if="empty" class="error">El formulario está vacío, todos los campos son obligatorios.
            </p>
          </div>
        </div>
      </fieldset>
      <div class="btn-container">
        <div>
          <button v-if="getIndirectPepsCount !== 0"
            @click.prevent="cancelIndirectPep">
            Cancelar
          </button>
        </div>
        <div>
          <button
            class="button btn--m"
            @click.prevent="saveIndirectPep">
            Guardar familiar
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { required, minLength, maxLength, requiredIf }
  from 'vuelidate/lib/validators'
import DatePicker from 'vuejs-datepicker'
import { es } from 'vuejs-datepicker/dist/locale'
import { format, isAfter } from 'date-fns'

import RELATIONS from '@/constants/relations'
import mixins from '@/mixins/index'

const validateName = (field) => /^[a-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1\s]+$/i.test((field))

export default {
  name: 'IndrectPepsForm',
  components: {
    DatePicker
  },
  mixins: [mixins],
  data () {
    return {
      indirectPepID: '',
      formSubmitted: false,
      keepWorkingAt: false,
      RELATIONS,
      format,
      isAfter,
      es: es,
      errors: false,
      empty: false,
      options: [
        {
          name: 'No',
          value: false
        },
        {
          name: 'Si',
          value: true
        }
      ],
      userIndirectPep: {
        name: '',
        fatherSurname: '',
        motherSurname: '',
        relationship: '',
        validStartDate: null,
        startWorkingDate: '',
        validEndDate: null,
        finishWorkingDate: null,
        profession: '',
        position: '',
        governmentDependence: '',
        currentJob: '',
        govFunds: ''
      }
    }
  },
  computed: {
    getIndirectPepsCount: function () {
      return this.$store.getters['pep/getIndirectPeps'].length
    }
  },
  validations: {
    userIndirectPep: {
      name: {
        required,
        minLength: minLength(2),
        validateName
      },
      fatherSurname: {
        required,
        minLength: minLength(2),
        validateName
      },
      motherSurname: {
        required,
        minLength: minLength(2),
        validateName
      },
      relationship: { required },
      validStartDate: {
        required,
        formattedDate (birthDate) {
          return (
            /^([0-2][0-9]|(3)[0-1])(-)(((0)[0-9])|((1)[0-2]))(-)\d{4}$/.test(this.dateFormat(birthDate))
          )
        },
        maxLength: maxLength(10)
      },
      validEndDate: {
        requiredIf: requiredIf(() => { return this.keepWorkingAt }),
        formattedDate (birthDate) {
          return (
            /^([0-2][0-9]|(3)[0-1])(-)(((0)[0-9])|((1)[0-2]))(-)\d{4}$/.test(this.dateFormat(birthDate))
          )
        },
        minorThan (birthDate) {
          if (this.keepWorkingAt) return true
          return this.isAfter(new Date(birthDate),
            new Date(this.userIndirectPep.validStartDate))
        },
        maxLength: maxLength(10)
      },
      profession: {
        required,
        minLength: minLength(2)
      },
      position: {
        required,
        minLength: minLength(2)
      },
      governmentDependence: {
        required,
        minLength: minLength(2)
      },
      currentJob: {
        required,
        minLength: minLength(2)
      },
      govFunds: {
        required
      }
    }
  },
  created: function () {
    this.indirectPepID = this.$store.getters['pep/getIndirectPepID']
    if (this.indirectPepID !== '') {
      const indirectPep =
        this.$store.getters['pep/getIndirectPepByID'](this.indirectPepID)
      this.userIndirectPep.name = indirectPep.name
      this.userIndirectPep.fatherSurname = indirectPep.middle_name
      this.userIndirectPep.motherSurname = indirectPep.last_name
      this.userIndirectPep.relationship = indirectPep.relationship
      this.userIndirectPep.validStartDate =
        new Date(`${indirectPep.start}T00:00:00`)
      this.userIndirectPep.validEndDate =
        indirectPep.end ? new Date(`${indirectPep.end}T00:00:00`) : null
      this.userIndirectPep.profession = indirectPep.profession
      this.userIndirectPep.position = indirectPep.position
      this.userIndirectPep.currentJob = indirectPep.government_dependence
      this.userIndirectPep.governmentDependence = indirectPep.current_job
      this.userIndirectPep.govFunds = indirectPep.gov_funds
    }
  },
  methods: {
    saveIndirectPep: function () {
      this.formSubmitted = true
      this.userIndirectPep.startWorkingDate =
        format(this.userIndirectPep.validStartDate, 'YYYY-MM-DD').toString()
      if (this.userIndirectPep.validEndDate !== null) {
        this.userIndirectPep.finishWorkingDate =
          format(this.userIndirectPep.validEndDate, 'YYYY-MM-DD').toString()
      }
      if (this.$v.userIndirectPep.$invalid) return false

      if (this.indirectPepID === '') {
        this.$store.dispatch('pep/addIndirectPeps', this.userIndirectPep)
      } else {
        this.updateIndirectPep()
      }
      this.$emit('displayAllInderectPeps', true)
    },
    cancelIndirectPep: function () {
      this.$store.dispatch('pep/removeIndirectPepID')
      this.$emit('displayAllInderectPeps', true)
    },
    updateIndirectPep: function () {
      let indirectPepToUpdate =
        {...this.userIndirectPep, id: this.indirectPepID}
      this.$store.dispatch(
        'pep/updateIndirectPep',
        indirectPepToUpdate
      )
    }
  }
}

</script>

<style lang="scss" scoped>

  .checkbox--label,
  .radio--label {
    display: inline-block;
  }

 .btn-container {
    display: flex;
    flex-direction: column;
    align-items: end;
  }

  @media (min-width: 768px) {
    .btn-container {
      flex-direction: row;
      justify-content: end;
    }

    .btn--m {
      margin-left: 2em;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/IndirectPeps/IndirectPepsForm.vue